module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("bYxOh"))).then(() => parcelRequire('d0iPb'));